// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validatePeruvianDocument(document: string): ?UserInputValidationError {
  if (!document) {
    return { id: 'empty'};
  } else if (!/^(\d{8,9}|\d{11})$/.test(document)) {
    return { id: 'invalid-pattern' };
  }
}
